if($('#patient-stories').length) {

    let searchContainer = $('#patient-stories'),
        resultsContainer = $('#patient-stories-results'),
        paginationContainer = $('#patient-stories-pagination-container'),
        paginationDisplay = $('.patient-stories-pagination-display'),
        page = 1;


    $(document).on('click', '.patient-stories-page-link', function (e) {
        e.preventDefault();
        page = $(this).data('page');
        patientStoriesSearch();
    });

    $(document).on('click', '.patient-stories-page-prev', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page--;
        patientStoriesSearch();
    });

    $(document).on('click', '.patient-stories-page-next', function (e) {
        e.preventDefault();
        if($(this).hasClass('disabled')) return;
        page++;
        patientStoriesSearch();
    });


    function patientStoriesSearch() {

        $.post("/wp-admin/admin-ajax.php", {
            'action': 'patient_stories_search',
            'page': page,
            // 'nonce': patient_stories_vars.nonce
        }, function (response) {

            resultsContainer.html(response.data.results);
            paginationContainer.html(response.data.pagination);
            paginationDisplay.html(response.data.pagination_display);

        });

    }

}
